export default __webpack_public_path__ + "static/media/Megosu - Made.com - 3.2760c4bf.mp4";